import React, { useState } from "react";
import reservationImg from "../assets/img/reservation.jpg";

const BookTable = () => {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        date: "",
        time: "",
        guests: "",
    });

    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState("");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const validate = () => {
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = "Name is required";
        }

        if (!formData.email.includes("@")) {
            newErrors.email = "Valid email is required";
        }

        if (!/^[6-9]\d{9}$/.test(formData.phone)) {
            newErrors.phone = "Enter 10 digit phone number";
        }

        if (!formData.date) {
            newErrors.date = "Date is required";
        }

        if (!formData.time) {
            newErrors.time = "Time is required";
        }

        if (!formData.guests || formData.guests <= 0) {
            newErrors.guests = "Guests must be greater than 0";
        }

        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const validationErrors = validate();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setSuccess("");
            return;
        }

        console.log("Booking Data:", formData);

        setSuccess("Table booked successfully!");

        setTimeout(() => {
            setSuccess("");
        }, 3000);

        setErrors({});

        setFormData({
            name: "",
            email: "",
            phone: "",
            date: "",
            time: "",
            guests: "",
        });
    };

    return (

        <React.Fragment>

            <section id="book-a-table" class="book-a-table section">

                <div class="container section-title" data-aos="fade-up">

                    <h2>Book A Table</h2>

                    <p>
                        <span>
                            Book Your
                        </span>

                        <span
                            class="description-title"
                        >
                            Stay With Us
                            <br />
                        </span>

                    </p>

                </div>

                <div class="container">

                    <div class="row g-0" data-aos="fade-up" data-aos-delay="100">

                        <div
                            class="col-lg-4 reservation-img"
                            style={{ backgroundImage: `url(${reservationImg})` }}
                        ></div>

                        <div
                            class="col-lg-8 d-flex align-items-center reservation-form-bg"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >

                            <form
                                onSubmit={handleSubmit}
                                role="form"
                                className="php-email-form"
                            >

                                <div className="row gy-4">

                                    <div className="col-lg-4 col-md-6">

                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            className="form-control"
                                            id="name"
                                            placeholder="Your Name"
                                            required=""
                                        />

                                    </div>
                                    {errors.name && <div className="invalid-feedback d-block text-danger">{errors.name}</div>}

                                    <div className="col-lg-4 col-md-6">

                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email" value={formData.email}
                                            onChange={handleChange}
                                            id="email"
                                            placeholder="Your Email"
                                            required=""
                                        />

                                    </div>
                                    {errors.email && <div className="invalid-feedback d-block text-danger">{errors.email}</div>}

                                    <div className="col-lg-4 col-md-6">

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="phone" id="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            placeholder="Your Phone"
                                            required=""
                                        />

                                    </div>
                                    {errors.phone && <div className="invalid-feedback d-block text-danger">{errors.phone}</div>}

                                    <div className="col-lg-4 col-md-6">

                                        <input
                                            type="date"
                                            name="date"
                                            value={formData.date}
                                            onChange={handleChange}
                                            className="form-control"
                                            id="date"
                                            placeholder="Date"
                                            min={new Date().toISOString().split("T")[0]}
                                            required=""
                                        />

                                    </div>
                                    {errors.date && (
                                        <div className="invalid-feedback d-block text-danger">
                                            {errors.date}
                                        </div>
                                    )}

                                    <div className="col-lg-4 col-md-6">

                                        <input
                                            type="time"
                                            className="form-control"
                                            name="time"
                                            value={formData.time}
                                            onChange={handleChange}
                                            id="time"
                                            placeholder="Time"
                                            required=""
                                        />

                                    </div>
                                    {errors.time && (
                                        <div className="invalid-feedback d-block text-danger">
                                            {errors.time}
                                        </div>
                                    )}

                                    <div className="col-lg-4 col-md-6">

                                        <input
                                            type="number"
                                            className="form-control"
                                            name="guests"
                                            value={formData.guests}
                                            onChange={handleChange}
                                            id="guests"
                                            placeholder="# of people"
                                            required=""
                                        />

                                    </div>
                                    {errors.guests && (
                                        <div className="invalid-feedback d-block text-danger">
                                            {errors.guests}
                                        </div>
                                    )}

                                </div>

                                <div className="form-group mt-3">

                                    <textarea
                                        className="form-control"
                                        name="message"
                                        rows="5"
                                        placeholder="Message">
                                    </textarea>

                                </div>

                                <div className="text-center mt-3">

                                    {success && (
                                        <div className="alert alert-success mt-3">
                                            {success}
                                        </div>
                                    )}

                                    <button
                                        type="submit">
                                        Book a Table
                                    </button>

                                </div>
                            </form>
                        </div>

                    </div>

                </div>

            </section>
        </React.Fragment>
    )
}

export default BookTable;